/* eslint-disable react-hooks/exhaustive-deps */
import '@ionic/react/css/core.css'
import './App.css'
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
  RetorikAgent,
  RetorikWidget,
  AvailableViews, 
  AvailableSubViews,
  useRetorikEvent,
  RetorikEvent,
  useMode,
  sendEvent,
  setLoaderClosed,
  useKioskParameterOpening} from "@davi-ai/retorik-framework";
import type {
  AddressData,
  WidgetConfiguration,
  ChatbotData,
  ViewsConfiguration,
  RetorikMenusConfiguration,
  Configuration,
  RetorikMainComponentConfiguration,
  
} from "@davi-ai/retorik-framework";
import { tenants, userData, colors } from "./data";
import { MapIcon, Map, Tenant, POIType, MapSettings, labels} from "@davi-ai/retorik-map";
// @ts-ignore
import { FullMenu } from "@davi-ai/retorik-framework-hospitality"
import { setupIonicReact } from '@ionic/react'
import { getDefaultLocalisationForActivital } from './utils/geoUtils';
import { botEventHandler } from './components/CustomBotEventHandler';
import { getTenant } from './utils/tenantService';
import { checkIfGeolocationIsInArea } from './utils/gpsUtils';
import { addBookingLinkAfterButton } from './utils/retorikUtils';
import { useDispatch, useSelector } from 'react-redux';
import { setMode } from '../../store/slices/botSlice';
import { setBotConfig } from '../../store/slices/botConfigSlice';
import { RootState } from '../../store/GlobalStore';
import { useGetBotConfigQuery } from '../../services/BotConfigAPI';
import VeilleManager from './components/veille/VeilleManager';
import VirtualKeyboard from './components/VirtualKeyboard';

//setupIonicReact()

interface RetorikWidgetProps {
  widgetConfig: WidgetConfiguration;
}

const widgetMode = false;

const addressData: AddressData =tenants.activital;

/*const bgDefault = "images/ActivitalFond.jpg";
const logoDefault ="images/logoACTIVITAL.png";

const bgimage = bgDefault;
const newsimage =bgDefault;*/

const viewsConfiguration: ViewsConfiguration = {
  homeRoute: "home",
  views: {
    home: {
      background: {
        //image: bgimage,
        style: "image",
      },
    },
    news: {
      intervalInSeconds: 2,
      loop: true,
      openingVideo: "",//"images/intro.mp4",
      background: {
        style: "image",
       // image: newsimage,
      },
    },
  },
};

const defaultChatbotData: ChatbotData = {
  size: "200vh",
  height: undefined,
}

const widgetConfig: WidgetConfiguration = 
  {
    button: {
      text: {
        color: '#fff',
        content:'BESOIN D\'AIDE'
      },
      image: {
        url: 'images/lea@2x.png',
        height:"3rem",
        marginY:true
      },
      border: {
        color: '#fff'
      },
      background:{
        color:"#0082CA"
      }
    },
    large: {}
  }


const App = () => {
  const askedForKioskParametersOpening = useKioskParameterOpening();
  const hospitalityFullMenu = new FullMenu(sendEvent).menu;
  const [retorikMap, setRetorikMap] = useState<JSX.Element>(<></>);
  const [_externalComponents, setExternalComponents] = useState<any | undefined>(undefined)
  const [_position, setPosition] = useState<{lat:number, lng:number} | undefined>(undefined)
  const [_selectedTenant, setSelectedTenant] = useState<Tenant|undefined>(undefined);
  const [_tenantList, setTenantList] = useState<{
    [key: string]: Tenant;
  }|undefined>(undefined);
const [injectConfig, setInjectConfig] = useState<
    RetorikMainComponentConfiguration & RetorikWidgetProps | undefined
  >(undefined)
  const [, setCurrentTenant] = useState<Tenant|undefined>();
  const dispatch = useDispatch();
  const retorikEvent = useRetorikEvent(); 
  const isUsedOnBorne = useSelector((state: RootState) => state.Auth.isUsedOnBorne);
  const veille = useSelector((state: RootState) => state.BotConfig.veille);
  const botDefaultPosition = useSelector((state: RootState) => state.BotConfig.defaultPosition);

  // Veille — inactivity state
  const [isVeille, setIsVeille] = useState(false);
  const veilleTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const veilleRef = useRef(veille);

  const currentMode = useMode();

  // BotConfig — fetch once on mount
  const { data: botConfigData, isFetching: isBotConfigFetching } = useGetBotConfigQuery();

  useEffect(() => {
    if (botConfigData) {
      console.log("Fetched bot config data:", botConfigData);
      dispatch(setBotConfig(botConfigData));
    }
  }, [botConfigData]);

  useEffect(() => {
    if(askedForKioskParametersOpening){
      console.log("Asked for kiosk parameters opening : ", askedForKioskParametersOpening);
    }
  }, [askedForKioskParametersOpening])
  useEffect(() => {
    console.log("currentMode", currentMode);
    dispatch(setMode(currentMode))
    //Modify injectedCSS
    const customCSSSpeech = `
      #retorik-container {
        min-height: initial !important;
        max-height: initial !important;
      }
    `;
    const customCSSText = `
      #retorik-container {
        height: calc(100vh - 60px) !important;
        min-height: initial !important;
        max-height: initial !important;
      }
    `;
    const host = document.querySelector("#retorik-shadow");
    const style = host?.shadowRoot?.querySelector("#customCSS");
    if (style) {
      style.innerHTML = (currentMode === 2 && !isUsedOnBorne) ? customCSSText : customCSSSpeech;
    }
  }, [currentMode, isUsedOnBorne])

  const defaultMenusConfig: RetorikMenusConfiguration = {
    baseMenu: [
      { view: AvailableViews.home, indice: 1 },
      {
        clickHandler: (): void => {},
        customDisplay: "mapDisplay",
        label: {
          "fr-FR": "Carte Interactive",
          "en-US": "Interactive map",
        },
        icon: <MapIcon />,
        indice: 2,
      },
      { view: AvailableViews.news, indice: 3 },
      { view: AvailableViews.weather, indice: 4 },
      { view: AvailableViews.emergency, indice: 5 }
    ],
    customMenu: [
      hospitalityFullMenu,
      []
    ],
    subMenu: [
      { view: AvailableSubViews.history, indice: 1 },
      { view: AvailableSubViews.tutorial, indice: 2 }
    ]
  }

  const defaultConfig: Configuration = {
    position: {
      searchForLocation: true,
    },
    isUsedOnBorne: isUsedOnBorne,
    
    /*logo:{
      src: logoDefault,
    },*/
    preventExpectedInputHint: true,
    enableTelemetry: false,
    hideMenu:false,
    enableConversationCookie:false,
    companyName: "ACTIVITAL",
    subCompanyMessage: " ",
    hideRetorikLogo: true,
    loaderInformationTexts: {
      vocal: {
        top: "Choisissez votre mode de conversation",
      },
      text: {
        top: "Choisissez votre mode de conversation",
      },
    },
    ...defaultMenusConfig
  }

  const eventHandle = useMemo(() => {
    return botEventHandler
  }, [])

  // Veille — keep ref in sync
  useEffect(() => {
    veilleRef.current = veille;
  }, [veille]);

  const veilleCountdownRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Veille — reset inactivity timer
  const resetVeilleTimer = useCallback(() => {
    if (veilleTimerRef.current) clearTimeout(veilleTimerRef.current);
    if (veilleCountdownRef.current) clearInterval(veilleCountdownRef.current);
    const v = veilleRef.current;
    if (v?.activated) {
      const delay = v.timer && v.timer >= 10 ? v.timer * 1000 : 180000;
      let remaining = Math.round(delay / 1000);
      console.log(`[Veille] Timer reset — ${remaining}s avant veille`);
      veilleCountdownRef.current = setInterval(() => {
        remaining -= 1;
        console.log(`[Veille] ${remaining}s`);
        if (remaining <= 0 && veilleCountdownRef.current) {
          clearInterval(veilleCountdownRef.current);
        }
      }, 1000);
      veilleTimerRef.current = setTimeout(() => {
        if (veilleCountdownRef.current) clearInterval(veilleCountdownRef.current);
        setIsVeille(true);
      }, delay);
    }
  }, []);

  // Veille — exit veille on user interaction
  const exitVeille = useCallback(() => {
    setIsVeille(false);
    resetVeilleTimer();
  }, [resetVeilleTimer]);

  // Veille — register / unregister document event listeners
  useEffect(() => {
    if (!veille?.activated) return;
    const events = ['click', 'touchstart', 'mousemove', 'keydown'] as const;
    events.forEach((e) => document.addEventListener(e, resetVeilleTimer));
    resetVeilleTimer();
    return () => {
      events.forEach((e) => document.removeEventListener(e, resetVeilleTimer));
      if (veilleTimerRef.current) clearTimeout(veilleTimerRef.current);
      if (veilleCountdownRef.current) clearInterval(veilleCountdownRef.current);
    };
  }, [veille?.activated, resetVeilleTimer]);

  // Veille — stop timer while veille is active
  useEffect(() => {
    if (isVeille && veilleTimerRef.current) clearTimeout(veilleTimerRef.current);
  }, [isVeille]);

  const botDefaultPositionRef = useRef(botDefaultPosition);
  useEffect(() => { botDefaultPositionRef.current = botDefaultPosition; }, [botDefaultPosition]);

  useEffect(() => {
    // Wait for BotConfig to finish loading before resolving position
    if (isBotConfigFetching) return;
    const handlePosition = async () => {
      var tenants= await getTenant();
      let selectedTenant = tenants["activital"];
      let defaultPos = botDefaultPositionRef.current ?? getDefaultLocalisationForActivital();
      let currentPosition : {lat: number;  lng: number;} = defaultPos
      if (navigator.geolocation && selectedTenant) {
          navigator.geolocation.getCurrentPosition(
              (position) => {
                if(checkIfGeolocationIsInArea(selectedTenant, {lat:position.coords.latitude, lng:position.coords.longitude})){
                  console.log("→ location good")
                  currentPosition = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  }
                 
                }
                else{
                  console.log("→location par defaut")
                  currentPosition = defaultPos
                }
                setPosition(currentPosition)
              },
              (err) => {
                  console.log("→ ERROR", err)
                  console.log("→ location par defaut")
                  currentPosition = defaultPos
                  setPosition(currentPosition)

              }
          );
      } else {
          console.log('→ La géolocalisation n\'est pas supportée par votre navigateur.');
          setPosition(currentPosition)
        
        }
        setSelectedTenant(selectedTenant)
        setTenantList(tenants);
    }
    handlePosition();
  }, [isBotConfigFetching]);

  useEffect(() => {
    const getTenantData = async () => {
        if(_selectedTenant && _tenantList && _position){
          console.log("Set current tenant & map")
          let mapSettings:MapSettings = {
            showFilter: [
              POIType.afaire,
              POIType.restaurant,
              POIType.hebergement,
              POIType.avoir,
              POIType.produit,
              POIType.service
            ]
          }
          setCurrentTenant(_selectedTenant);
          setRetorikMap(
            <Map
              activeTenant={_selectedTenant.name}
              tenantList={_tenantList}
              userLocation={_position}
              settings={mapSettings}
            />
          );
          let copyConfig = {...defaultConfig}
          if(_position){
            copyConfig.position = {
              latitude: _position.lat,
              longitude: _position.lng
            }
          }
          const newConfig =
          {
                config: copyConfig,
                viewsConfig: viewsConfiguration,
                chatbotData:defaultChatbotData,
                addressData,
                userData,
                //agentData: characters.zahra,
                //customVoice:voices.multi,
                defaultMode: 1,
                widgetConfig,
                colors,
                skipLoader: false,
          }
          console.log("newConfig", newConfig)
          setInjectConfig(newConfig)
          if(isUsedOnBorne){
            setLoaderClosed(true)
          }
        }
        
    } 
    getTenantData();
    
  }, [_tenantList, _selectedTenant, _position]);


    useEffect(() => {
      if(retorikMap){
        const _externalComponents = [
          {
            component: retorikMap,
            name: "mapDisplay",
          },
        ];
        setExternalComponents(_externalComponents);
      }
    }, [retorikMap]);

    useEffect(() => {
      console.log("retorikEvent", retorikEvent, isUsedOnBorne);
      if (retorikEvent && retorikEvent === RetorikEvent.DetailViewOpen) {
        console.log("Add Button");
        setTimeout(() => {
            addBookingLinkAfterButton(isUsedOnBorne);
        }, 500)
      }
    }, [retorikEvent]);
    
    if (injectConfig && _externalComponents) {
      const chatbot = widgetMode ? (
        <RetorikWidget {...injectConfig} externalComponents={_externalComponents} externalEventHandler={eventHandle}/>
      ) : (
        <RetorikAgent {...injectConfig} externalComponents={_externalComponents} externalEventHandler={eventHandle}/>
      );

      return (
        <>
          {isUsedOnBorne && <VirtualKeyboard />}
          {veille?.activated && isVeille ? (
            <VeilleManager timerRefresh={exitVeille} injectConfig={injectConfig} />
          ) : (
            chatbot
          )}
        </>
      );
    }
    else {
      return <></>
    }
};


export default App;
